import { FC, ReactElement, lazy, Suspense } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import {TopBar} from '@/components';

const Home = lazy(() => import('@/page/Home'));
const VoteList = lazy(() => import('@/page/voteList'));
const Vote = lazy(() => import('@/page/vote'));
const Governance = lazy(() => import('@/page/Governance'));
const RpcVote = lazy(() => import('@/page/rpcVote'));
const BackupNode = lazy(() => import('@/page/BackupNode'));

const MainRoute: FC = (): ReactElement => {
    return (
        <Suspense fallback={<div></div>}>
            <TopBar>
                <Switch>
                    <Route path="/home" component={Home} />
                    <Route path="/vote-list" component={VoteList} />
                    <Route path="/vote" component={Vote} />
                    <Route path="/governance" component={Governance} />
                    <Route path="/rpc-vote" component={RpcVote} />
                    <Route path="/backup-node" component={BackupNode} />
                    <Route exact path={'*'} render={() => <Redirect to="/vote-list" />} />
                </Switch>
            </TopBar>
        </Suspense>
    );
};
export default MainRoute;
